module.exports = __webpack_public_path__ + "img/analyst.a205b865.svg";